import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useLanguageDropdownItems = () => {
    const { t } = useTranslation();

    const languageDropdownItems: { value: string; label: string }[] = useMemo(() => {
        return [
            { value: "de", label: t("language.german") },
            { value: "en", label: t("language.english") },
            { value: "fr", label: t("language.french") },
            { value: "it", label: t("language.italian") }
        ];
    }, [t]);

    return {
        languageDropdownItems
    };
};
